export default __webpack_public_path__ + "static/media/expBlue.fc91e37c.svg";